import { ProximityApiFactory, ProximityJudgeDiscussion } from '@/api'
import BaseUserActionRequest from '@/requests/baseRequest'
import { AxiosPromise } from 'axios'
/**
 * 協議要否判断
 */
export class CreateRequest extends BaseUserActionRequest {
  private proximityJudgeDiscussion: ProximityJudgeDiscussion
  private proximityId: number

  /**
   * @param proximityId 近接工事詳細ID
   * @param proximityJudgeDiscussion 更新内容
   * @returns 更新結果など
   */
  constructor(proximityId: number, proximityJudgeDiscussion: ProximityJudgeDiscussion) {
    super()
    this.proximityId = proximityId
    this.proximityJudgeDiscussion = proximityJudgeDiscussion
  }

  protected request(): AxiosPromise<ProximityJudgeDiscussion> {
    const api = ProximityApiFactory()
    // APIを実行
    return api.proximityJudgeDiscussion(this.proximityId, this.proximityJudgeDiscussion)
  }
}
